import { configureStore } from '@reduxjs/toolkit';
import rootReducers from './reducers';

const Store = (preloadedState?: any) => {

  const store = configureStore({
      reducer: rootReducers,
      preloadedState: preloadedState
  })

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;

}

const _store = Store();

export type RootState = ReturnType<typeof _store.getState>;
export type AppDispatch = typeof _store.dispatch;

export default Store;
